import { useMemo } from 'react';

const TIMEZONE_OPTIONS = [
	'Europe/Amsterdam',
	'Europe/London',
	'Europe/Berlin',
	'Europe/Brussels',
	'Europe/Paris',
	'Europe/Madrid',
	'Europe/Rome',
	'Europe/Zurich',
	'Europe/Vienna',
	'Europe/Stockholm',
	'Europe/Oslo',
	'Europe/Copenhagen',
	'Europe/Helsinki',
	'Europe/Warsaw',
	'Europe/Prague',
	'Europe/Dublin',
	'Europe/Lisbon',
	'Europe/Athens',
	'Europe/Bucharest',
	'Europe/Istanbul',
] as const;

function getTimezoneOffsetHours(timezone: string, date: Date): number {
	const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
	const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
	return (tzDate.getTime() - utcDate.getTime()) / (1000 * 60 * 60);
}

function getTimezoneCityName(timezone: string): string {
	return timezone.split('/').pop()?.replace(/_/g, ' ') ?? timezone;
}

function formatTimezoneOffset(hours: number): string {
	const sign = hours >= 0 ? '+' : '-';
	const abs = Math.abs(hours);
	const h = Math.floor(abs);
	const m = Math.round((abs - h) * 60);

	if (m === 0) return `UTC${sign}${h}`;
	return `UTC${sign}${h}:${m.toString().padStart(2, '0')}`;
}

export default function useTimezoneSelectOptions() {
	return useMemo(() => {
		const now = new Date();

		return TIMEZONE_OPTIONS.map((tz) => {
			const city = getTimezoneCityName(tz);
			const offset = formatTimezoneOffset(getTimezoneOffsetHours(tz, now));

			return {
				value: tz,
				label: `${city} (${offset})`,
			};
		});
	}, []);
}
